import * as SystemJSLoader from "systemjs";
import { Compiler, ComponentFactoryResolver, Injectable, SystemJsNgModuleLoader } from "@angular/core";
import { Http } from "@angular/http";
import { Observable, Subject } from "rxjs";
import { ITCITenantServices, ITenantMap, AbstractTciTenant, TciTenantModelService } from "./tci-tenant.model";
import { TCITenantServiceLoader } from "./tci-tenant-service-loader";
import { ITCIUserInfo, TCITenantAppType } from "@tci/common";
import { NgWindowRefService } from "../ng-shared/ng-services/ng-window-ref.service";
import { NgUserService } from "../ng-shared/ng-services/ng-user.service";

declare var SystemJS: SystemJSLoader.System;

// tslint:disable:max-line-length
@Injectable()
export class TciTenantService {
    private static instance: TciTenantService;

    private initialized = false;
    private initialized$: Subject<boolean> = new Subject();

    public static getInstance(
        http: Http,
        resolver: ComponentFactoryResolver,
        loader: SystemJsNgModuleLoader,
        compiler: Compiler,
        windowRef: NgWindowRefService,
        modelService: TciTenantModelService,
        remoteServiceLoader: TCITenantServiceLoader,
        userService: NgUserService): TciTenantService {
        if (!TciTenantService.instance) {
            TciTenantService.instance = new TciTenantService(
                http,
                resolver,
                loader,
                compiler,
                windowRef,
                modelService,
                remoteServiceLoader,
                userService
            );
        }
        return TciTenantService.instance;
    }

    public static setRef(tenant: TCITenantAppType, key: string, ref: any) {
        const refKey = `refProperty-${tenant.toString()}-${key}`;
        TciTenantService[refKey] = ref;
    }

    public static getRef(tenant: TCITenantAppType, key: string): any {
        const refKey = `refProperty-${tenant.toString()}-${key}`;
        return TciTenantService[refKey];
    }

    private constructor(
        private http: Http,
        private resolver: ComponentFactoryResolver,
        private loader: SystemJsNgModuleLoader,
        private compiler: Compiler,
        private windowRef: NgWindowRefService,
        private modelService: TciTenantModelService,
        private remoteServiceLoader: TCITenantServiceLoader,
        private userService: NgUserService
    ) {
        this.initialized$.subscribe(val => this.initialized = val);
        this.userService.getUserInfo()
            .flatMap(res => this.init(res)) // pass user info
            .subscribe(
                res => {
                    this.modelService.bindTenantService(this);
                    // console.log("The tenants (from tci-tenant.service):", res);
                },
                err => {
                    console.error("Error loading all tenants", err);
                }
            );
    }

    private init(userInfo: ITCIUserInfo): Observable<ITenantMap> {
        /**
         * This mapping between discoverable tenants is important
         * as some tenants are not discoverable e.g. node, bw
         * We might have to add them here manually as those
         * tenant implementation will exist in web-server
         * code base until there is a dedicated microservice
         * for those Tenant app types.
         * The Remote services will gather only those tenants
         * that has Ng2 implementation and has implemented
         * `${tenant.name}-svc` entry point in their moduleconfig.json
         */
        return this.remoteServiceLoader.getTenantServices<ITCITenantServices>(AbstractTciTenant)
            .flatMap(svcMap => {
                const onInitObs: Observable<boolean>[] = Object.entries(svcMap)
                    .map(([key, value]) => {
                        this.modelService.addTenant(TCITenantAppType.fromString(key), value);
                        return this.userService.getUserInfo()
                            .flatMap(res => value.init(res))
                            .map(res => {
                                if (res === true) {
                                    return true;
                                }

                                console.log("Tenant", key, "did not return TRUE on module init", res);
                                return false;
                            });
                    });

                return Observable.merge(...onInitObs).toArray();
            })
            .map(res => {
                this.initialized$.next(true);
                return this.modelService.getTenants();
            });
    }

    public isInit() {
        return this.initialized;
    }

    public onInit(): Observable<boolean> {
        if (!this.initialized) {
            return this.initialized$;
        } else {
            return Observable.of(true);
        }
    }
}
